import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import {
  checkIsBirdviewChartLimitChanged,
  getBirdviewChartControls,
  getBirdviewChartLimit,
} from '../../BirdviewChartCard.utils'

export function useBirdviewChartCardControls({
  chart,
  controls,
  rowSpan,
  onChangeControls,
}) {
  const { t } = useTranslation()

  const { metric, metricOptions, period, periodOptions } =
    getBirdviewChartControls({ chart, controls, t })
  const limit = getBirdviewChartLimit({ chart, rowSpan })

  useEffect(() => {
    if (checkIsBirdviewChartLimitChanged({ chart, controls, limit })) {
      onChangeControls(chart.sectionKey, { limit })
    }
  }, [limit])

  function handleSelectPeriod(option) {
    onChangeControls(chart.sectionKey, { period: option.value })
  }

  function handleSelectMetric(option) {
    onChangeControls(chart.sectionKey, { metric: option.value })
  }

  return {
    handleSelectMetric,
    handleSelectPeriod,
    metric,
    metricOptions,
    period,
    periodOptions,
  }
}
